/* MoRetro Studio V20 — Dashboard utile
   Ajoute des indicateurs atelier sans toucher à la logique imprimantes.
*/
window.MTS = window.MTS || {};

(function(MTS){
  "use strict";

  function moneyValue(v){
    const n = Number(v || 0);
    return Number.isFinite(n) ? n : 0;
  }

  function projectAmount(p){
    return moneyValue(
      p.finalPrice ||
      p.quoteTotal ||
      p.quote?.final ||
      p.quote?.total ||
      p.quote?.price ||
      p.autoQuote?.quote?.final ||
      p.autoQuote?.quote?.suggested
    );
  }

  function isThisMonth(ts){
    const d = ts?.toDate ? ts.toDate() : ts ? new Date(ts) : null;
    if(!d || Number.isNaN(d.getTime())) return false;
    const now = new Date();
    return d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth();
  }

  function stats(){
    const projects = Array.isArray(MTS.state.projects) ? MTS.state.projects : [];

    const active = projects.filter(p=>!["done","archived"].includes(p.status || "new")).length;
    const quotesWaiting = projects.filter(p=>["quoted","accepted"].includes(p.status || "new")).length;
    const paymentsToCheck = projects.filter(p=>(p.status || "new")==="quoted" && p.shopifyDraftOrderId && !p.shopifyOrderId).length;
    const toShip = projects.filter(p=>["ready"].includes(p.status || "new")).length;
    const production = projects.filter(p=>["paid","printing","finishing","ready"].includes(p.status || "new")).length;
    const monthRevenue = projects
      .filter(p=>["paid","printing","finishing","ready","shipped","done"].includes(p.status || "new"))
      .filter(p=>isThisMonth(p.paidAt || p.updatedAt || p.createdAt))
      .reduce((s,p)=>s + projectAmount(p),0);

    return {active, quotesWaiting, paymentsToCheck, toShip, production, monthRevenue};
  }

  function render(){
    const panel = document.getElementById("mtsPanelDashboard");
    if(!panel) return;

    let box = document.getElementById("mtsV20Dashboard");
    if(!box){
      box = document.createElement("div");
      box.id = "mtsV20Dashboard";
      box.className = "mts-v20-dashboard";
      panel.prepend(box);
    }

    const s = stats();

    box.innerHTML = `
      <article><span>Projets actifs</span><strong>${s.active}</strong><em>hors terminés / archivés</em></article>
      <article><span>Devis à suivre</span><strong>${s.quotesWaiting}</strong><em>envoyés ou acceptés</em></article>
      <article><span>Paiements à vérifier</span><strong>${s.paymentsToCheck}</strong><em>liens Shopify ouverts</em></article>
      <article><span>Production</span><strong>${s.production}</strong><em>payé → prêt</em></article>
      <article><span>À expédier</span><strong>${s.toShip}</strong><em>colis à préparer</em></article>
      <article><span>CA du mois</span><strong>${MTS.money(s.monthRevenue)}</strong><em>payé / produit</em></article>
    `;
  }

  function start(){
    render();
    setInterval(render, 3000);
  }

  MTS.DashboardV20 = { render, start };
})(window.MTS);
